module.exports = __webpack_public_path__ + "static/media/4.10537f2f.png";